import { error as logError } from './logger';
import { isBlankString } from './stringUtils';

export function getSiteWithSiteId(siteConfig, siteId) {
    if (!_.isObject(siteConfig) || isBlankString(siteId)) {
        logError('Site config is not an object or site ID is not a string or blank');
        return;
    }

    const sites = _.get(siteConfig, 'sites', []);

    return _.find(sites, (site) => site.siteId === siteId);
}

export function getInventoryPoolForSiteId(siteConfig, countryCode, siteId) {
    if (!_.isObject(siteConfig) || isBlankString(countryCode) || isBlankString(siteId)) {
        logError('Site config is not an object, or country code or site ID is not a string or blank');
        return;
    }

    const site = getSiteWithSiteId(siteConfig, siteId);

    if (!site) {
        logError(`Cannot find site in site config with ID ${siteId}`);
        return;
    }

    const inventoryPools = _.get(site, 'inventoryPools', []);

    try {
        for (let inventoryPool of inventoryPools) {
            const countries = _.get(inventoryPool, 'country', []);
            const countryCodes = _.map(countries, 'countryCode');

            if (_.includes(countryCodes, countryCode)) {
                return _.get(inventoryPool, 'poolId');
            }
        }

        return _.get(site, 'defaultInventoryPool');
    } catch (err) {
        logError('error getting inventory pool, using default pool', err);
        return _.get(site, 'defaultInventoryPool');
    }
}
